module.exports = __webpack_public_path__ + "images/f0cb9cd2109ce95e9d0d933e33e8ddcc.png";


//////////////////
// WEBPACK FOOTER
// ./js/components/assets/man/12.png
// module id = 372
// module chunks = 0